import { Button, styled } from '@mui/material';

export const InputW = styled('div')`
  max-width: 100%;
  width: 100%;
  display: flex;
  align-items: flex-end;

  & > div {
    flex: 1;
  }
`;

export const SubmitPasswordButton = styled(Button)`
  width: 100%;
  height: 50px;
  border-radius: 4px;
  font-weight: 400;
  font-size: 18px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  box-shadow: none;

  &:hover {
    box-shadow: none;
  }
`;
